/**
 * 結算月界純函式（Phase 7 帳務結算）。
 * 業務時間存 UTC unix ms、月界以 GMT+8 為準（全系統顯示時區）。
 * 不引日期函式庫 — GMT+8 無夏令時間，固定位移即可。
 */
export const GMT8_OFFSET_MS = 8 * 60 * 60 * 1000;

/** GMT+8 的當月 [1日00:00, 下月1日00:00)，回 UTC ms 半開區間。month: 1–12 */
export function monthRangeGmt8(year: number, month: number): { startMs: number; endMs: number } {
  return {
    startMs: Date.UTC(year, month - 1, 1) - GMT8_OFFSET_MS,
    endMs: Date.UTC(year, month, 1) - GMT8_OFFSET_MS,
  };
}

/** UTC ms → GMT+8 月份鍵 "YYYY-MM"（每月訂單分組、結算期間標籤用） */
export function monthKeyGmt8(ms: number): string {
  const d = new Date(ms + GMT8_OFFSET_MS);
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, "0")}`;
}
